import React, { ReactNode, useEffect, useState } from 'react';

import { useApiMutation, useApiQuery } from '../../hooks/useApi';
import { AppHeader } from '../common/AppHeader';
import { replaceMapKey } from '../map/placeUtils';

type Props = {
  id: number;
  action?: ReactNode;
};

export function BuildingHeader({ id, action }: Props) {
  const { data: building } = useApiQuery('getBuilding', id);
  const [imgSrc, setImgSrc] = useState<string | undefined | null>(undefined);

  const refreshPhotoMutationFn = useApiMutation('refreshPhoto', {
    onSuccess: (data) => {
      if (data.photo_reference) {
        const newImgSrc = replaceMapKey(data.photo_reference);
        setImgSrc(newImgSrc);
      } else {
        setImgSrc(null);
      }
    },
    onError: (error) => {
      setImgSrc(null);
    },
  });

  useEffect(() => {
    if (building?.photo_reference) {
      const imgSrcWithKey = replaceMapKey(building.photo_reference);
      setImgSrc(imgSrcWithKey);
    } else if (building) {
      setImgSrc(null);
    }
  }, [building]);

  const handleImageError = () => {
    if (building?.photo_reference) {
      refreshPhotoMutationFn(id);
    } else {
      setImgSrc(null);
    }
  };

  return (
    <>
      <AppHeader
        background={imgSrc}
        onBackgroundError={handleImageError}
        title={building?.name}
        subTitle={[building?.street, building?.streetNumber]
          .filter(Boolean)
          .join(' ')}
        action={action}
      />
      {/* {<BuildingNotificationStatus id={id} />} */}
    </>
  );
}
